import { Card, CardContent } from "@/pages/newHome/ui/card";
import img1 from "@/assets/newHome/lead-data.svg";
import crm from "@/assets/newHome/crm.svg";
import ai from "@/assets/newHome/ai-agent.svg";
import automation from "@/assets/newHome/marketing-automation.svg";
import quotes from "@/assets/newHome/quotes.svg";
import contracts from "@/assets/newHome/analytics.svg";
import featureImage from "@/assets/newHome/01@2x.webp";
import AiAgentImage from "@/assets/newHome/03@2x.webp";
import AutomationImage from "@/assets/newHome/5@2x.webp";
// import quotesImage from "@/assets/newHome/05@2x.webp";
import quotesImage from "@/assets/newHome/quotes-kanban@2x.webp";
import crmImage from "@/assets/newHome/04@2x.webp";
import AnalyticsImage from "@/assets/newHome/06@2x.webp";
import { useState } from "react";
// import TypeWriterEffect from "@/components/animations/typewriter-effect";
import TypewriterText from "@/components/animations/typewriter-text";

export const FeaturesByAnima = (): JSX.Element => {
  const initialFeatures = [
    {
      id: 1,
      name: "Lead Data",
      image: img1,
      isActive: true,
      renderImage: featureImage,
    },
    {
      id: 2,
      name: "AI Agent",
      isActive: false,
      image: ai,
      isComplex: true,
      renderImage: AiAgentImage,
    },
    {
      id: 3,
      name: "CRM",
      image: crm,
      isActive: false,
      renderImage: crmImage,
    },
    {
      id: 4,
      name: "Automation",
      image: automation,
      isActive: false,
      renderImage: AutomationImage,
    },
    {
      id: 5,
      name: "Quotes",
      image: quotes,
      isActive: false,
      renderImage: quotesImage,
    },
    {
      id: 6,
      name: "Analytics",
      image: contracts,
      isActive: false,
      renderImage: AnalyticsImage,
    },
  ];

  const [features, setFeatures] = useState(initialFeatures);
  const [selectedFeature, setSelectedFeature] = useState(initialFeatures[0]);

  const handleFeatureClick = (clickedId: number) => {
    const updated = features.map((f) =>
      f.id === clickedId ? { ...f, isActive: true } : { ...f, isActive: false }
    );
    setFeatures(updated);
    const selected = updated.find((f) => f.id === clickedId);
    if (selected) setSelectedFeature(selected);
  };

  return (
    <section className="flex flex-col items-center py-10 md:py-[60px] md:px-0 w-full bg-white gap-y-5 pointer-events-auto">
      <div className="text-center w-[80%] mt-4">
      <h2 className="xl:text-3xl md:text-xl text-lg font-semibold opacity-0 absolute whitespace-pre-wrap pointer-events-none">
    <span className="text-charcoal">Sales Made Simple for </span>
    <span className="text-primary">Subcontractors</span>
    <br />
    <span className="text-charcoal">and </span>
    <span className="text-primary">Building Suppliers</span>
  </h2>
        <h2 className="xl:text-3xl md:text-xl text-lg font-semibold min-h-[96px]">
          {/* <span className="text-charcoal">Sales Made Simple for </span>
          <span className="text-primary">
            Subcontractors
            <br />
          </span>
          <span className="text-charcoal">and </span>
          <span className="text-primary">Building Suppliers</span> */}
          
          
          <TypewriterText
            fullTextParts={[
              { text: "Sales Made Simple for ", className: "text-charcoal" },
              { text: "Subcontractors\n", className: "text-primary" },
              { text: "and ", className: "text-charcoal" },
              { text: "Building Suppliers", className: "text-primary" },
            ]}
          />
         
        </h2>
        {/* <TypeWriterEffect text="Sales Made Simple for Subcontractors and Building Suppliers"/> */}
      </div>

      <Card className=" w-[100%] mx-auto sm:w-full rounded-2xl border-none shadow-none">
        <CardContent className="p-0">
          <div className="px-12 lg:px-4 md:px-0">
            <div className="grid grid-cols-3 gap-y-[0.5rem] gap-x-0 sm:gap-3 md:flex md:items-center md:justify-center md:gap-6">
              {features.map((feature) => (
                <div
                  key={feature.id}
                  onClick={() => handleFeatureClick(feature.id)}
                  className={`cursor-pointer flex flex-col items-center justify-center w-full h-[80px] md:w-[80px] md:h-[85px] xl:w-[110px] xl:h-[110px] relative transition-all duration-200
          ${
            feature.isActive
              ? "bg-[#f6f6f6] rounded-[10px]"
              : "bg-white rounded-[10px]"
          }`}
                >
                  <div className="w-[36px] h-[36px] md:w-[40px] md:h-[40px] flex items-center justify-center mb-1">
                    <img
                      className="w-full h-full object-contain"
                      alt={feature.name}
                      src={feature.image}
                    />
                  </div>
                  <div
                    className={`text-center font-['Outfit',Helvetica] font-medium text-[10px] md:text-sm leading-tight md:leading-5 whitespace-nowrap ${
                      feature.isActive ? "text-[#28af4a]" : "text-[#828282]"
                    }`}
                  >
                    {feature.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="lg:w-[70%] md:w-[85%] sm:w-[55%] w-full ml-16 sm:ml-0 mt-6 2xl:mt-0">
        <img
          className="w-full h-auto 2xl:h-[75vh] object-cover 2xl:object-contain rounded-[7.32px]"
          alt={selectedFeature.name}
          src={selectedFeature.renderImage}
        />
      </div>
    </section>
  );
};
